import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-theme-icon',
  templateUrl: './theme-icon.component.html',
  styleUrls: ['./theme-icon.component.less']
})
export class ThemeIconComponent implements OnInit {
  @Input() isOnTheme: boolean
  @Input() isCompareMode: boolean
  @Output() onThemeAction = new EventEmitter<boolean>()

  constructor() { }

  ngOnInit() {
    this._onThemeAction()
  }

  _onThemeAction(): void {
    this.onThemeAction.emit(this.isOnTheme);
    this.isOnTheme = !this.isOnTheme
  }

  checkIsOnTheme(){
    if (!this.isCompareMode && this.isOnTheme === null){
      return true
    }else if(!this.isCompareMode && this.isOnTheme){
      return true
    }else if(!this.isCompareMode && !this.isOnTheme){
      return false
    }else if(!this.isOnTheme){
      return true
    }else if(this.isOnTheme){
      return false
    }else{
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/icon-dropdown/theme-icon/theme-icon.component.ts